<!--
 * @description: 
 * @Author: HaoJG
 * @Date: 2021-10-12 09:47:12
 * @Lasteditors: HaoJG
 * @LastEditTime: 2022-03-20 09:57:33
-->
<template>
  <div>
    <div class="maintitle">员工考核</div>
    <el-divider></el-divider>
    <el-row class="text-left" :gutter="20">
      <el-col :span='6'>
        <el-input v-model='keyword' placeholder="请输入搜索关键词" size='mini' @keyup.enter.native="searchList"></el-input>
      </el-col>
      <el-date-picker v-model="month" type="month" placeholder="选择考核月份" size='mini'>
      </el-date-picker>
      <el-button @click="searchList" size='mini' class="margin-left">筛选</el-button>
      <el-button @click="outList" size='mini' class="margin-left">导出</el-button>
    </el-row>
    <el-table :data="list" row-key="id" border>
      <el-table-column prop="name" width='100' label="员工姓名" align="center"></el-table-column>
      <el-table-column prop="department" label="部门"></el-table-column>
      <el-table-column prop="month" label="考核月份" width='100' align="center"></el-table-column>
      <!-- <el-table-column label="自评">
        <template slot-scope="scope">
          <span>{{formatExcellent(scope.row.selfexcellent)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="负责人点评">
        <template slot-scope="scope">
          <span>{{formatExcellent(scope.row.leaderexcellent)}}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="最终点评">
        <template slot-scope="scope">
          <span>{{formatExcellent(scope.row.excellent)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="最终得分" prop='score'></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button-group>
            <el-button @click="ass(scope)" size='mini'>查看</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :current-page="page" :page-sizes="pagesizes" :page-size="pagesize" @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    <el-dialog :title='crntemployee' :visible.sync="assDiv" :show-close="false" width='100%' :close-on-click-modal="false">
      <el-table :data="alist" row-key="id" border width="100%">
        <el-table-column v-for="(item,index) in trList" :key="index" :label="item.label" :width="item.width" :fixed="item.fixed" :align="item.align">
          <template slot-scope="scope">
            <span v-html='scope.row[item.prop]' v-if="item.html==1"></span>
            <span v-else>{{ scope.row[item.prop] }}</span>
            <!-- <template v-else>
              <el-input v-model='scope.row[item.prop]' v-if="item.edit==1 && scope.row.readonly!=1" :type="item.type"></el-input>
              <span v-html='scope.row[item.prop]'></span>
            </template> -->
          </template>
        </el-table-column>
      </el-table>
      <table class="excellent-table" v-if='needExcellent==1'>
        <tr>
          <th style='width:300px;'>优秀标准</th>
          <th v-for="(item,index) in shenheList" :key="index">
            {{ item.name }}
          </th>
        </tr>
        <tr v-for='(item,index) in excellentlist' :key='item.id' :index='index'>
          <td v-html="item.standard" class="text-left"></td>
          <td v-for="(it,i) in shenheList" :key="i">
            <span v-if="i!='final'">{{getBeizhu(item.detail,it.uuid)}}</span>
          </td>
        </tr>
        <tr>
          <td>评选结果</td>
          <td v-for="(item,index) in assessinfo.detail" :key="index">
            {{formatExcellentFull(item.excellent)}}
          </td>
        </tr>
        <tr>
          <td>备注</td>
          <td v-for="(item,index) in assessinfo.detail" :key="index">
            <span v-html="item.beizhu"></span>
          </td>
        </tr>
      </table>
      <div>
        <el-button @click="assDiv=false" size='mini'>返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [], //考核员工列表
      keyword: '',
      total: 0,
      page: sessionStorage.getItem('final_assess_page') ? parseInt(sessionStorage.getItem('final_assess_page')) : 1,
      excellentTypeList: JSON.parse(sessionStorage.getItem('excellentType')),
      info: [],
      assessinfo: {},
      assDiv: false,
      month:'',
      crntemployee:'',
      needExcellent:0,
      excellentlist:[],
      trList: [],
      canRefuse: 0,
      shenheList: {},
      uuid: sessionStorage.getItem('employeeuuid')
    };
  },
  computed: {
    alist() {
      let temp = {
        id: 0,
        title: '合计',
        readonly: 1,
      }
      let shenhe = [];
      for(let item in this.shenheList){
        shenhe.push(this.shenheList[item].uuid)
        temp[this.shenheList[item].uuid+'score'] = 0;
      }
      for (let item in this.info) {
        for(let i in shenhe){
          temp[shenhe[i]+'score'] += isNaN(parseFloat(this.info[item][shenhe[i]+'score'])) ? 0 : parseFloat(this.info[item][shenhe[i]+'score']);
        }
      }
      return this.info.concat(temp);
    },
  },
  methods: {
    searchList(){
      this.page = 1;
      this.getlist();
    },
    getlist() {
      this.$axios({
        url: this.HOST + "/kaohe/viewass/getAssessList",
        method: "post",
        data: {
          page: this.page,
          pagesize: this.pagesize,
          keyword: this.keyword,
          month:this.month
        },
      }).then((res) => {
        this.list = res.data.list.data;
        this.total = res.data.list.total;
      });
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getlist();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getlist();
      sessionStorage.setItem('leader_assess_page', p);
    },
    formatExcellent(e) {
      if(e==-1) return;
      for (let i in this.excellentTypeList) {
        if (this.excellentTypeList[i].excellent_id == e) return this.excellentTypeList[i].excellent_title;
      }
    },
    formatExcellentFull(e) {
      if(e==-1) return;
      for (let i in this.excellentTypeList) {
        if (this.excellentTypeList[i].excellent_id == e) return this.excellentTypeList[i].excellent_title;
      }
      return '不评';
    },
    getBeizhu(item,uuid) {
      for(let i in item){
        if(i == uuid){
          return item[i].beizhu
        }
      }
    },
    ass(scope) {
      this.$axios({
        url: this.HOST + "/kaohe/viewass/getAssByAid",
        method: "post",
        data: {
          id: scope.row.id
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.info = res.data.list;
          this.assessinfo = res.data.assinfo;
          for(let item in this.assessinfo.detail){
            this.assessinfo.detail[item].excellent = parseInt(this.assessinfo.detail[item].excellent)
          }
          this.assDiv = true;
          this.needExcellent = res.data.needExcellent;
          this.crntemployee = scope.row.name;
          this.excellentlist = res.data.excellentlist;
          this.trList = res.data.trList;
          this.canRefuse = res.data.canRefuse;
          this.shenheList = res.data.shenheList
        }
      });
    },
    outList(){
      this.$axios({
        url: this.HOST + "/kaohe/viewass/outAssess",
        method: "post",
        data: {
          keyword:this.keyword,
          month:this.month,
        },
        responseType: "blob"
      }).then(res => {
        let blob = new Blob([res.data]);
        let fileName = '考核详情.csv';
        if ("download" in document.createElement("a")) {
          // 不是IE浏览器
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(url); // 释放掉blob对象
        } else {
          // IE 10+
          window.navigator.msSaveBlob(blob, fileName);
        }
      });
    },
  },
  created: function () {
    this.getlist();
  },
};
</script>
<style scoped>
.itemgroup {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 20px 20px 0 0;
  margin-bottom: 10px;
  width: 100%;
  box-sizing: border-box;
}
.itemgroup * {
  box-sizing: border-box;
}
.item-title {
  line-height: 28px;
}
</style>